import { all, call, put, takeEvery, select } from 'redux-saga/effects'
import { util } from '../../util'

import * as actions from './actions'
import * as URL from './url'
import { api } from '../api'
import * as helper from './helper'
import { history } from '../../util/history'
import { constants } from '../../constants'
import { setCommonError } from '../Common/actions'

function* fetchPushNotificationByID(action) {
    try {
        yield put(actions.notificationLoadingStart())
        const data = { search: { _id: action.payload } }
        const {
            data: { notifications },
        } = yield call(api, URL.fetchPushNotificationsURL, 'POST', data)
        if (!notifications.length) {
            throw Error('No record')
        }
        yield put(actions.fetchPushNotificationByIdSuccess(notifications[0]))
    } catch (e) {
        console.log('saga fetchPushNotificationByID', e)
        yield put(actions.fetchPushNotificationByIdFailed())
    }
}

function* updatePushNotification(action) {
    try {
        yield put(actions.notificationLoadingStart())
        const currNotif = yield select(util.getCurrNotif)
        const email = yield select(util.getUserEmail)
        const payload = helper.setUpdateNotificationPayload(currNotif, email, action.payload)
        const { data } = yield call(api, URL.updatePushNotificationsURL, 'POST', payload)
        yield put(
            actions.updatePushNotificationSuccess({
                notification_details: data,
                notification_update_message: 'Changes has been saved!',
            })
        )
    } catch (e) {
        console.log('saga updatePushNotification error', e)
        yield put(actions.notificationLoadingEnd())
    }
}

function* updatePushNotificationTitle(action) {
    try {
        yield put(actions.notificationLoadingStart())
        const currNotif = yield select(util.getCurrNotif)
        const email = yield select(util.getUserEmail)
        const payload = helper.setUpdateNotificationPayload(currNotif, email, action.payload)
        const { data } = yield call(api, URL.updatePushNotificationsURL, 'POST', payload)
        yield put(
            actions.updatePushNotificationTitleSuccess({
                notification_details: data,
                notification_update_message: 'Changes has been saved!',
                isNotificationTitleUpdated: true,
            })
        )
    } catch (e) {
        console.log('saga updatePushNotificationTitle error', e)
        yield put(actions.notificationLoadingEnd())
    }
}

function* fetchPushNotificationsList(action) {
    try {
        const isSideMenuOpened = yield select(util.isSideMenuOpened)
        if (isSideMenuOpened) {
            return
        }
        yield put(actions.notificationLoadingStart())
        const res = yield call(api, URL.fetchPushNotificationsURL, 'POST', action.payload)
        yield put(
            actions.fetchPushNotificationsListSuccess({
                notifications_list: res.data.notifications,
                count: res.data.count,
                size: action.payload.size,
                pageNo: res.data.pageNo,
                order: action.payload.sort[Object.keys(action.payload.sort)[0]],
                orderBy: Object.keys(action.payload.sort)[0],
            })
        )
    } catch (e) {
        console.log('saga fetchPushNotificationsList error', e)
        yield e && e.message && put(actions.setPushNotificationsError(e.message))
        yield put(actions.notificationLoadingEnd())
    }
}

function* createPushNotification(action) {
    try {
        yield put(actions.notificationLoadingStart())
        const email = yield select(util.getUserEmail)
        const data = { ...action.payload, updated_by: email }
        const {
            data: { notification },
        } = yield call(api, URL.createPushNotificationURL, 'POST', data)
        yield put(actions.createPushNotificationSuccess(notification))
        yield put(actions.modalClose())
        history.push({
            pathname: `/dashboard/push-notifications/${notification._id}`,
            state: { isNotificationCreated: true },
        })
    } catch (e) {
        console.log('saga createPushNotification error', e)
        yield put(actions.notificationLoadingEnd())
    }
}

function* deletePushNotification(action) {
    try {
        yield put(actions.notificationLoadingStart())
        const data = {
            _id: action.payload,
        }
        yield call(api, URL.deletePushNotificationURL, 'DELETE', data)
        const deleteMsg = 'Notification(s) have been deleted successfully'
        yield put(actions.displayUpdateSuccesAlert(deleteMsg))
        yield put(actions.notificationLoadingEnd())
        history.push(constants.routePaths.push_notifications.path)
    } catch (e) {
        console.log('saga deletePushNotification error', e)
        yield put(actions.notificationLoadingEnd())
    }
}

function* publishPushNotification(action) {
    try {
        yield put(actions.notificationLoadingStart())
        const payload = {
            publish: {
                _id: action.payload,
            },
        }
        const { data } = yield call(api, URL.publishPushNotificationURL, 'POST', payload)
        yield put(
            actions.updatePushNotificationSuccess({
                notification_details: data,
                notification_update_message: 'Notification has been Published!',
            })
        )
    } catch (e) {
        console.log('saga publishPushNotification error', e)
        yield put(actions.notificationLoadingEnd())
    }
}

function* unPublishPushNotification(action) {
    try {
        yield put(actions.notificationLoadingStart())
        const payload = {
            _id: action.payload,
        }

        const { data } = yield call(api, URL.unPublishPushNotificationURL, 'POST', payload)
        /** After Un publishing a notification status should change to 'Ready'  */
        if (data.status !== 'Ready' && data.status !== 'Completed') {
            throw Error('Unpublish Failed')
        }
        yield put(
            actions.updatePushNotificationSuccess({
                notification_details: data,
                notification_update_message:
                    data.status === 'Completed'
                        ? 'Notification has been sent'
                        : 'Notification has been Unpublished!',
            })
        )
    } catch (e) {
        yield put(actions.notificationLoadingEnd())
        if (e.message === 'Unpublish Failed') {
            console.log('unpublish notification error', e)
            yield put(setCommonError('An Error Occurred. Please try again.'))
        }
    }
}

function* fetchNotificationUsers() {
    try {
        yield put(actions.userLoadingStart())
        const {
            data: { created_by, updated_by },
        } = yield call(api, URL.getUsersURL, 'GET')
        const filters = yield select(util.getNotificationsFilter)
        const updatedFilters = filters.map(filter => {
            const cloneFilter = { ...filter }
            if (cloneFilter.key === 'created_by') {
                cloneFilter['baseFilterList'] = created_by
            }
            if (cloneFilter.key === 'updated_by') {
                cloneFilter['baseFilterList'] = updated_by
            }
            return cloneFilter
        })
        yield put(actions.updateNotificationsFilter(updatedFilters))
    } catch (error) {
        console.log('fetch notification users', error)
        yield put(actions.userLoadingEnd())
    }
}

function* fetchDMAList() {
    try {
        yield put(actions.notificationLoadingStart())
        const { data } = yield call(api, URL.getDMAList, 'GET')
        yield put(actions.fetchDMAListSuccess(data.dma))
    } catch (e) {
        yield put(actions.notificationLoadingEnd())
        console.log('fetch DMA list error ', e)
    }
}

export default function* watchPushNotifications() {
    yield all([
        takeEvery(actions.actionTypes.SAGA_FETCH_NOTIFICATION_USERS, fetchNotificationUsers),
        takeEvery(
            actions.actionTypes.SAGA_FETCH_PUSH_NOTIFICATION_BY_ID,
            fetchPushNotificationByID
        ),
        takeEvery(actions.actionTypes.SAGA_FETCH_PUSH_NOTIFICATIONS, fetchPushNotificationsList),
        takeEvery(actions.actionTypes.SAGA_CREATE_PUSH_NOTIFICATION, createPushNotification),
        takeEvery(actions.actionTypes.SAGA_UPDATE_PUSH_NOTIFICATION, updatePushNotification),
        takeEvery(actions.actionTypes.SAGA_DELETE_PUSH_NOTIFICATION, deletePushNotification),
        takeEvery(actions.actionTypes.SAGA_PUBLISH_PUSH_NOTIFICATION, publishPushNotification),
        takeEvery(actions.actionTypes.SAGA_UN_PUBLISH_PUSH_NOTIFICATION, unPublishPushNotification),
        takeEvery(
            actions.actionTypes.SAGA_UPDATE_PUSH_NOTIFICATION_TITLE,
            updatePushNotificationTitle
        ),
        takeEvery(actions.actionTypes.SAGA_FETCH_DMA_LIST, fetchDMAList),
    ])
}
